<template>
  <div class="page boxes">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'BuyMenu' | lang }}</div>
      <button @click="goTo('/cart', false, true)" :aria-label="dictValue('CartWithItems', {nitems: cartLength})">
        <i class="fa fa-fw fa-shopping-cart" :badge="cartLengthLabel"></i>
      </button>
    </header>
    <div v-if="isMobile">
      <p  v-if="!manifest.hideQrcodeTickets">{{ 'BuyETicketsTip' | lang }}</p>
      <button v v-if="!manifest.hideQrcodeTickets"  @click="continueWithoutCsc" class="withicon">
        <span class="iconbox"><i class="fa fa-fw fa-ticket"></i></span>
        <span>{{ 'Etickets' | lang }}</span>
      </button>

      <p style="margin-top:2rem">{{ 'BuyOnCSCTip' | lang }}</p>
      <button @click="continueWithCsc" class="withicon reverse">
        <span class="iconbox"><i class="fa fa-fw fa-id-card-o"></i></span>
        <span>{{ 'Cscproducts' | lang }}</span>
      </button>
      <p v-if="!manifest.hideBuyCard" style="margin-top:2rem">{{ 'BuyCSCTip' | lang }}</p>
      <button v-if="!manifest.hideBuyCard" @click="continueForCsc" class="withicon">
        <span class="iconbox"><i class="fa fa-fw fa-id-card-o"><i class="fa fa-plus second-icon"></i></i></span>
        <span>{{ 'Cscs' | lang }}</span>
      </button>
    </div>
    <div v-else>
      <!--<p style="margin-top:2rem">{{ 'BuyOnCSCTip' | lang }}</p>-->
      <button @click="continueWithCsc" class="withicon reverse">
        <span class="iconbox"><i class="fa fa-fw fa-id-card-o"></i></span>
        <span>{{ 'Cscproducts' | lang }}</span>
      </button>
      <!--<p style="margin-top:2rem">{{ 'BuyCSCTip' | lang }}</p>-->
      <button v-if="!manifest.hideBuyCard" @click="continueForCsc" class="withicon">
        <span class="iconbox"><i class="fa fa-fw fa-id-card-o"><i class="fa fa-plus second-icon"></i></i></span>
        <span>{{ 'Cscs' | lang }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'

export default {
  name: 'ProductTypes',
  mixins: [ page, databaseWrapperMixin ],
  methods: {
    continueWithoutCsc () {
      if (this.isEticketCart === false) {
        this.goTo('/wrongcarttype/' + this.cartType, false)
        return
      }
      this.buying = {
        csc: null,
        pagecount: 0
      }
      this.checkLoginAndGoTo('/products/eticket/0')
    },
    continueWithCsc () {
      if (this.isCscCart === false) {
        this.goTo('/wrongcarttype/' + this.cartType, false)
        return
      }
      /*if (this.userProfile && this.userProfile.tessere && this.userProfile.tessere.length === 1) {
        let csc = this.userProfile.tessere[0]
        this.buying = {
          csc,
          pagecount: 0
        }
        this.goTo('/products/csc/' + csc.MediaSerialNumber, false)
      } else {
        this.checkFullLoginAndGoTo('/cscselector')
      }*/
      this.checkFullLoginAndGoTo('/cscselector')
    },
    continueForCsc () {
      if (this.isCscCart === false) {
        this.goTo('/wrongcarttype/' + this.cartType, false)
        return
      }

      if(this.manifest.forceImageToBuyCard==true && !this.userProfile.profilo.Photo)
      {
        this.internalBus.$emit('notify:error', {
                                  text: this.dictValue('profileImageToContinue') ,
                                  key: this.notifierKey,
                                  timeout: 10000
                                })         
      }
      else
      {
            if (this.userProfile) {
            this.buying = {
              csc: null,
              pagecount: 0
            }
            this.goTo('/products/newcsc/0', false)
          } else {
            this.checkFullLoginAndGoTo('/products/newcsc/0')
          }
      }
      // this.goTo('/products/newcsc/0', false)  
    }
  }
}
</script>

<style></style>
